import {filter} from 'lodash'
import {useEffect, useState, useRef, useCallback} from 'react'
// material
import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import Stack from '@material-ui/core/Stack'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import TableRow from '@material-ui/core/TableRow'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import TableContainer from '@material-ui/core/TableContainer'
import TablePagination from '@material-ui/core/TablePagination'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import {useTheme} from '@material-ui/core/styles'
import Fab from '@material-ui/core/Fab'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import Autocomplete from '@material-ui/core/Autocomplete'
import TableHead from '@material-ui/core/TableHead'
import EditIcon from '@mui/icons-material/Edit'

// icon
import {Icon} from '@iconify/react'
import CloseIcon from '@mui/icons-material/Close'
import closeIcon from '@iconify/icons-eva/close-circle-outline'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import searchFill from '@iconify/icons-eva/search-fill'
// components
import archiveOutline from '@iconify/icons-eva/archive-outline'
import {Link as RouterLink} from 'react-router-dom'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import Page from '../components/Page'
import Label from '../components/Label'
import Scrollbar from '../components/Scrollbar'
import SearchNotFound from '../components/SearchNotFound'
import {UserListHead, UserListToolbar, UserMoreMenuUpdate} from '../components/_dashboard/user'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DesktopDatePicker} from '@mui/x-date-pickers/DesktopDatePicker'
import LoadingScreen from 'components/LoadingScreen'
import userAPI from 'utils/api/users'
import {logSuccessAction, ACTION_CATEGORIES} from 'utils/actionLogger'
import storage from 'utils/storage'
import Bugsnag from '@bugsnag/js'
import QrReader from 'react-qr-reader'
import {CSVLink} from 'react-csv'
import GetAppIcon from '@material-ui/icons/GetApp'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import {styled} from '@material-ui/core/styles'

import BreaklistRemark from 'components/breaklistRemark'
import Editable from 'components/editable/number'
import useUpdateScheduleValues from 'hooks/useUpdateScheduleValues'

import {useBlocker} from 'react-router'

const dayjs = require('dayjs')
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Manila')
const moment = require('moment-timezone')
moment().tz('Asia/Manila').format()

const TABLE_HEAD = [
  {id: 'name', label: 'Employee Name', alignRight: false},
  {id: 'dayswork', label: 'Days Work', alignRight: false},
  {id: 'hourswork', label: 'Hours Work', alignRight: false},
  {id: 'hourstardy', label: 'Tardiness (Minutes)', alignRight: false},
  {id: 'overtime', label: 'Overtime (Hours)', alignRight: false},
  {id: 'nightdiff', label: 'Night Diff (Hours)', alignRight: false},
  {id: 'restday', label: 'RD Work (Hours)', alignRight: false},
  {id: 'legalholiday', label: 'Legal Holiday (Hours)', alignRight: false},
  {id: 'specialholiday', label: 'Special Holiday (Hours)', alignRight: false},
  {id: ''},
]

const MODAL_HEAD = [
  {id: 'date', label: 'Date', alignRight: false},
  {id: 'schedule', label: 'Schedule', alignRight: false},
  {id: 'timein', label: 'Time-in', alignRight: false},
  {id: 'timeout', label: 'Time-out', alignRight: false},
  {id: 'workinghours', label: 'Working Hours', alignRight: false},
  {id: 'lates', label: 'Lates (Minutes)', alignRight: false},
  {id: 'ot', label: 'Overtime (Hours)', alignRight: false},
  {id: 'nightdiff', label: 'Night Diff (Hours)', alignRight: false},
  {id: 'rd', label: 'RestDay (Hours)', alignRight: false},
  {id: 'legalholiday', label: 'Legal Holiday (Hours)', alignRight: false},
  {id: 'specialholiday', label: 'Special Holiday (Hours)', alignRight: false},
  {id: 'remarks', label: 'Remarks', alignRight: false},
  {id: 'action', label: 'Action', alignRight: false},
]

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
  justifyContent: 'center',
}

const SearchStyle = styled(OutlinedInput)(({theme}) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {width: 320, boxShadow: theme.customShadows.z8},
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}))

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

function applySortFilter(array, comparator, query) {
  // Check if the array is valid and not empty
  if (!Array.isArray(array) || array.length === 0) {
    return [] // Return an empty array if input is invalid or empty
  }

  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })

  if (query) {
    return filter(array, (_user) =>
      _user.displayName
        ? _user.displayName.toLowerCase().indexOf(query.toLowerCase()) !== -1
        : _user.empName
        ? _user.empName.toLowerCase().indexOf(query.toLowerCase()) !== -1
        : '',
    )
  }

  return stabilizedThis.map((el) => el[0])
}

function applySortFilterSchedule(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })

  if (query) {
    return filter(array, (_user) => (_user.date ? _user.date : ''))
  }
  return stabilizedThis.map((el) => el[0])
}

export default function User() {
  const ref = useRef(null)
  const getTodayDateOnly = () => {
    const today = new Date()
    return new Date(today.getFullYear(), today.getMonth(), today.getDate())
  }
  const today = new Date()

  // Create a date object for yesterday
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  const [page, setPage] = useState(0)
  const [pageSchedule, setPageSchedule] = useState(0)
  const [order, setOrder] = useState('asc')
  const [selected, setSelected] = useState([])
  const [orderBy, setOrderBy] = useState('name')
  const [filterName, setFilterName] = useState('')
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [rowsPerPageSchedule, setRowsPerPageSchedule] = useState(5)
  const [storeBreaklist, setStoreBreaklist] = useState([])
  const [open, setOpen] = useState(null)
  const [isLoading, setLoading] = useState(false)
  const [openDialogGenerate, setOpenDialogGenerate] = useState(false)
  const [id, setId] = useState()
  const [name, setName] = useState()
  const [user, setUser] = useState({})
  const [action, setAction] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [openUpdates, setOpenUpdates] = useState(false)
  const d = new Date()
  const [date, setDate] = useState(d.setDate(d.getDate() - 1))
  const [fromDate, setFromDate] = useState(dayjs(yesterday).format('YYYY-MM-DD'))
  const [toDate, setToDate] = useState(dayjs(yesterday).format('YYYY-MM-DD'))
  const [daysWork, setDaysWork] = useState('')
  const [hoursWork, setHoursWork] = useState('')
  const [hoursTardy, setHoursTardy] = useState(0)
  const [overtime, setOvertime] = useState(0)
  const [nightdiff, setNightdiff] = useState(0)
  // const [addRemarksMode, setAddRemarksMode] = useState(null)
  const [remarks, setRemarks] = useState('')
  const [employeeRecord, setEmployeeRecord] = useState([])
  const [resultRequest, setresultRequest] = useState([])
  const [openDialog, setOpenDialog] = useState(false)
  const [submittedBy, setSubmittedBy] = useState('')
  const [cutoff, setCutoff] = useState(1)
  const [company, setCompany] = useState([])
  const [selectedCompany, setSelectedCompany] = useState('')
  const [openQR, setOpenQR] = useState(false)
  const [count, setCount] = useState()
  const csvLinkRef = useRef()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [recordChanges, setRecordChanges] = useState({})
  const [updateUserId, setUpdateUserId] = useState(null)
  const [openCreateScheduleDialog, setOpenCreateScheduleDialog] = useState(false)
  const [from, setFrom] = useState(new Date())
  const [to, setTo] = useState(new Date())
  const [scheduleDate, setScheduleDate] = useState(new Date())
  const [breakMin, setBreakMin] = useState(0)
  const [position, setPosition] = useState('')
  const [selectedId, setSelectedId] = useState('')
  const [selectedBreaklistId, setSelectedBreaklistId] = useState('')

  let addedRemarks = useRef({})

  let {updateSchedValues, scheduleValuesOf, totalValuesOfUserId, getUpdatedScheduleValues, resetScheduleValues} =
    useUpdateScheduleValues()

  let breaklistSaved = useRef(true)

  const handleCloseModal = () => {
    localStorage.setItem('hasSeenBreaklistModal', 'true')
    setOpenDialogGenerate(null)
  }

  //confirm user when generated breaklist not saved
  let breaklistNotSavedBlocker = useBlocker(({location, retry}) => {
    if (location.pathname !== '/stores/breaklist-info' && !breaklistSaved.current) {
      if (window.confirm('You have unsaved breaklist, continue?')) {
        retry()
      }
    } else {
      retry()
    }

    return true
  })

  //save breaklist

  const saveRemark = useCallback((id, remark) => {
    let savedRemarks = addedRemarks.current
    savedRemarks[`${id}`] = remark
    addedRemarks.current = savedRemarks
  }, [])

  const handleInputChange = (event) => {
    setSubmittedBy(event.target.value)
  }

  const handleEditSchedule = (_id, date) => {
    setScheduleDate(date)
    setSelectedId(_id)
    setOpenCreateScheduleDialog(true)
  }

  const handleCloseCreateScheduleDialog = () => {
    setOpenCreateScheduleDialog(false)
  }

  function getTimeDifferenceSchedule(startTime, endTime) {
    // Parse the start and end times
    const startParts = startTime.split(':')
    const endParts = endTime.split(':')

    // Create Date objects for the times
    const startDate = new Date()
    startDate.setHours(startParts[0], startParts[1], 0, 0)

    const endDate = new Date(startDate)
    endDate.setHours(endParts[0], endParts[1], 0, 0)

    // Handle the case where end time is on the next day
    if (endDate <= startDate) {
      endDate.setDate(endDate.getDate() + 1)
    }

    // Calculate the difference in milliseconds
    const timeDifferenceMilliseconds = endDate - startDate

    // Convert the difference to hours and minutes
    const hoursDifference = Math.floor(timeDifferenceMilliseconds / (1000 * 60 * 60))
    const minutesDifference = Math.floor((timeDifferenceMilliseconds % (1000 * 60 * 60)) / (1000 * 60))

    return {
      hours: hoursDifference,
      minutes: minutesDifference,
    }
  }

  const handleSaveSchedule = async () => {
    setLoading(true)
    let totalHours = 0
    let totalHours2 = 0
    if (typeof from !== 'string' || typeof to !== 'string') {
      alert('Please choose start shift and end shift')
      setLoading(false)
    } else if (!position) {
      alert('Please choose position')
      setLoading(false)
    } else {
      if (typeof from === 'string' || typeof to === 'string') {
        const startDate = new Date(`2023-03-15T${from}`)
        const endDate = new Date(`2023-03-15T${to}`)

        const diffInMilliseconds = endDate - startDate
        const diffInSeconds = diffInMilliseconds / 1000
        const diffInMinutes = diffInSeconds / 60
        const diffInHours = diffInMinutes / 60
        const hours = breakMin / 60
        totalHours = getTimeDifferenceSchedule(from, to)
        totalHours2 = totalHours.hours + totalHours.minutes / 60 - hours
      }

      const utcDate = moment(scheduleDate).format('L')
      const utcDate2 = moment(utcDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
      const updateData = {
        uid: selectedId,
        date: utcDate,
        from: from,
        to: to,
        totalHours: totalHours2,
        breakMin: breakMin,
        position: position,
      }

      const response = await userAPI.post_schedule(updateData)
      if (response.status === 200) {
        const data = {
          id: selectedBreaklistId,
          from: utcDate2,
          to: utcDate2,
        }
        try {
          const result = await userAPI.get_schedule_with_range(data)
          setEmployeeRecord(result.data)
          // // setSpecificReport(result.data); // Uncomment if needed
          setOpen(selectedBreaklistId)
        } catch (error) {
          console.error('Error fetching schedule:', error)
        } finally {
          handleGenerateBreaklist()
          setLoading(false)
        }
        alert('Schedule updated successfully')
        setOpenCreateScheduleDialog(false)

        setLoading(false)
        // window.location.reload()
      } else {
        alert('Something went wrong please try again later')
        setLoading(false)
      }
      setLoading(false)
    }
  }

  /*const [specificSchedule, setSpecificSchedule] = useState([])*/

  useEffect(() => {
    const load = async () => {
      const local_user = await storage.getUser()
      if (!local_user) return

      const user = JSON.parse(local_user)
      setUser(user)
      const fomattedDate = moment(date).format('YYYY-MM-DD')
      if (user.role >= 3) {
        const getCompany = await userAPI.get_group_store(user._id)
        if (getCompany.status === 200) {
          if (getCompany.data.report.store.length > 0) {
            setCompany(getCompany.data.report.store)
            setSelectedCompany(getCompany.data.report.store[0])
          } else {
            setCompany([])
            setSelectedCompany()
          }

          const data = {
            store: getCompany.data.report.store[0],
          }
        } else {
          setStoreBreaklist()
        }
      }
    }

    load()
  }, [])
  const updateHoursTardy = (id, data) => {
    setStoreBreaklist((prevData) =>
      prevData.map((item) =>
        item._id === id
          ? {
              ...item,
              hourstardy: data.hoursTardy,
              overtime: data.overtime,
              nightdiff: data.nightdiff,
              restday: data.restday,
            }
          : item,
      ),
    )
  }

  const UpdateSubmit = (data) => {
    updateHoursTardy(data.id, data)

    // If this is a close dialog action, reset the updateUserId
    if (data.closeDialog) {
      setUpdateUserId(null)
    }
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = storeBreaklist.map((n) => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1))
    }
    setSelected(newSelected)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleFilterByName = (event) => {
    setFilterName(event.target.value)
  }

  const handleChangePageSchedule = (event, newPage) => {
    setPageSchedule(newPage)
  }

  const handleChangeRowsPerPageSchedule = (event) => {
    setRowsPerPageSchedule(parseInt(event.target.value, 10))
    setPageSchedule(0)
  }

  const handleFilterByNameSchedule = (event) => {
    setFilterName(event.target.value)
  }

  const handleClose = () => {
    // setAddRemarksMode(null)
    setOpen(null)
  }

  const handleChangeFromDate = async (date) => {
    const dateOnly = date ? dayjs(date).format('YYYY-MM-DD') : null
    setFromDate(dateOnly)

    // Date Validation
    if (dateOnly && toDate) {
      const from = dayjs(dateOnly)
      const to = dayjs(toDate)
      const diffInDays = to.diff(from, 'day')

      if (diffInDays > 15) {
        alert('Date range must not exceed 16 days')
        setFromDate(null)
        setToDate(null)
      }
    }
  }

  const handleChangeToDate = async (date) => {
    const dateOnly = date ? dayjs(date).format('YYYY-MM-DD') : null
    setToDate(dateOnly)

    if (dateOnly && fromDate) {
      const from = dayjs(fromDate)
      const to = dayjs(dateOnly)
      const diffInDays = to.diff(from, 'day')

      if (diffInDays > 15) {
        alert('Date range must not exceed 16 days')
        setToDate(null)
        setFromDate(null)
      }
    }
  }

  function isDateIncluded(date, array) {
    return array.some((item) => item.date === date)
  }

  const handleCellClick = async (id) => {
    setLoading(true)
    setSelectedBreaklistId(id)
    const data = {
      id: id,
      from: fromDate,
      to: toDate,
    }
    try {
      const result = await userAPI.get_schedule_with_range(data)
      setEmployeeRecord(result.data)
      // setSpecificReport(result.data); // Uncomment if needed
      setOpen(id)
    } catch (error) {
      console.error('Error fetching schedule:', error)
    } finally {
      setLoading(false)
    }
  }

  // const handleAddRemarks = (index) => {
  //   setAddRemarksMode(index)
  // }

  // const handleSaveRemarks = () => {
  //   setAddRemarksMode(null)
  // }

  /*  const handleBlur = async () => {
      console.log("Success")
    }*/

  const handleGenerateBreaklist = async () => {
    setOpen(null)
    //remove previous remarks added
    addedRemarks.current = {}
    setRecordChanges({})
    resetScheduleValues()
    if (!localStorage.getItem('hasSeenBreaklistModal')) {
      setOpenDialogGenerate(true)
      localStorage.setItem('hasSeenBreaklistModal', 'true')
    }
    setLoading(true)
    if (user.role >= 3) {
      if (!selectedCompany) {
        alert('Please select store')
      } else {
        if (fromDate > toDate) {
          alert('From date must be before or equal to end date')
        } else {
          const data = {
            from: fromDate,
            to: toDate,
            store: selectedCompany,
          }
          const result = await userAPI.get_breaklist(data)
          if (result.data.success) {
            setStoreBreaklist(result.data.data)
            if (result.data.data.length > 0) {
              breaklistSaved.current = false
            }
            setresultRequest(JSON.parse(result.config.data))
            setLoading(false)
          } else {
            setStoreBreaklist([])
            alert('Invalid Dates. Breaklist date already submitted and saved.')
            setLoading(false)
          }
        }
      }
    } else {
      if (fromDate > toDate) {
        alert('From date must be before or equal to end date')
      } else {
        const data = {
          from: fromDate,
          to: toDate,
          store: user.company,
        }
        const result = await userAPI.get_breaklist(data)
        if (result.data.success) {
          setStoreBreaklist(result.data.data)
          setresultRequest(JSON.parse(result.config.data))
          setLoading(false)
        } else {
          setStoreBreaklist([])
          alert('Invalid Dates. Breaklist date already submitted and saved.')
          setLoading(false)
        }
      }
    }

    setPageSchedule(0)

    setLoading(false)
  }

  const handleSaveBreaklist = async () => {
    setOpenDialog(false)
    setLoading(true)

    // Get updated schedule values object for later use
    const updatedValues = getUpdatedScheduleValues()
    const totals = updatedValues.totals || {}

    // Create updated employee data with proper number conversions
    // Since the backend doesn't correctly integrate the updatedScheduleValues with the employees,
    // we need to pre-calculate the final values here
    let updatedEmployeeData = storeBreaklist.map((user) => {
      let userIdValues = totalValuesOfUserId(user._id)
      const userId = user._id

      // Calculate final values with proper number handling
      const finalHoursTardy = Number(user.hourstardy || 0) + Number(userIdValues.hoursTardy || 0)
      const finalOvertime = Number(user.overtime || 0) + Number(userIdValues.overtime || 0)
      const finalRestday = Number(user.restday || 0) + Number(userIdValues.rd || 0)
      const finalNightdiff = Number(user.nightdiff || 0) + Number(userIdValues.nightdiff || 0)

      return {
        ...user,
        hourstardy: finalHoursTardy,
        overtime: finalOvertime,
        restday: finalRestday,
        nightdiff: finalNightdiff,
        // Format the numbers consistently
        hourswork: Number(user.hourswork || 0),
        dayswork: Number(user.dayswork || 0),
      }
    })

    const data = {
      from: resultRequest.from,
      to: resultRequest.to,
      store: resultRequest.store,
      employees: updatedEmployeeData,
      generatedby: submittedBy,
      employeecount: storeBreaklist.length,
      cutoff: cutoff,
      remarks: addedRemarks.current,
      updatedScheduleValues: updatedValues,
      recordChanges: recordChanges,
    }

    try {
      const result = await userAPI.post_save_breaklist(data)

      if (result.status === 200) {
        alert('Saving breaklist Success')

        // Log successful breaklist save
        const storeInfo = user.role >= 3 ? selectedCompany : user.company
        const cutoffText = cutoff === '1' ? '1st Cutoff' : '2nd Cutoff'
        const dateRange = `${fromDate} to ${toDate}`
        const employeeCount = storeBreaklist.length

        // Calculate totals for the log
        const totalHoursWork = storeBreaklist.reduce((sum, emp) => sum + Number(emp.hourswork || 0), 0)
        const totalDaysWork = storeBreaklist.reduce((sum, emp) => sum + Number(emp.dayswork || 0), 0)
        const totalOvertimeHours = storeBreaklist.reduce((sum, emp) => sum + Number(emp.overtime || 0), 0)

        logSuccessAction({
          user: user._id,
          company: storeInfo,
          userDisplay: {
            name: user.displayName,
            email: user.email,
          },
          role: user.role,
          action: 'Saved Breaklist',
          category: ACTION_CATEGORIES.BREAKLIST,
          details: `Successfully saved breaklist for ${storeInfo}. Period: ${dateRange} (${cutoffText}). Employees: ${employeeCount}. Total Hours: ${totalHoursWork.toFixed(
            2,
          )}. Total Days: ${totalDaysWork.toFixed(1)}. Total OT: ${totalOvertimeHours.toFixed(
            2,
          )}. Submitted by: ${submittedBy}`,
        })

        // Clear all data instead of reloading the page
        setStoreBreaklist([])
        setEmployeeRecord([])
        addedRemarks.current = {}
        resetScheduleValues()
        breaklistSaved.current = true
        setRecordChanges({})
        setPage(0)
        setPageSchedule(0)
        if (open !== null) {
          setOpen(null)
        }
      } else {
        alert('Something went wrong, please try again!')
      }
    } catch (error) {
      console.error('Error saving breaklist:', error)
      alert('Something went wrong, please try again!')
    } finally {
      localStorage.removeItem('hasSeenBreaklistModal')
      setLoading(false)
      setSubmittedBy('')
      setOpenDialog(false)
    }
  }

  const handleSubmit = () => {
    setOpenDialog(true)
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - storeBreaklist.length) : 0

  const filteredStoreBreaklist = applySortFilter(storeBreaklist, getComparator(order, orderBy), filterName)

  const filteredEmployeeRecord = employeeRecord
    ? applySortFilterSchedule(employeeRecord, getComparator(order, orderBy), filterName)
    : false

  const isUserNotFound = filteredStoreBreaklist.length === 0

  // const handleInputChange = (e, id, field) => {
  //   const { value } = e.target;
  //   setInputValues(prevState => ({
  //     ...prevState,
  //     [id]: {
  //       ...prevState[id],
  //       [field]: value
  //     }
  //   }));
  // };

  const handleSaveUpdates = () => {
    console.log('Hellow')
  }

  const handleClickOpen = () => {
    setOpen(true)
    setIsOpen(false)
  }

  const handleClickOpenUpdates = (name) => {
    setOpenUpdates(true)
  }

  const handleCloseUpdates = () => {
    setOpenUpdates(false)
  }

  const getCsvData = () => {
    const csvData = []
    csvData.push([`Company: `, `${user.company}`])
    csvData.push([`Date: `, `${fromDate} to ${toDate}`])
    csvData.push(['', '', '', '', '', ''])
    csvData.push(['', '', '', '', '', ''])
    csvData.push([
      'Employee',
      'Days Work',
      'Hours Work',
      'Tardiness( Minutes )',
      'Overtime( Hours )',
      'Night Diff( Hours )',
      'RD Work( Hours )',
    ])
    if (storeBreaklist) {
      storeBreaklist.map((data) => {
        csvData.push([
          data.empName,
          data.dayswork,
          data.hourswork,
          data.hourstardy,
          data.overtime,
          data.nightdiff,
          data.restday,
        ])
      })
    }

    return csvData
  }

  const handleExportBreaklist = async () => {
    csvLinkRef.current.link.click()
  }

  const [inputValues, setInputValues] = useState(
    filteredEmployeeRecord.reduce((acc, row) => {
      acc[row._id] = {
        hoursTardy: row.hoursTardy,
        overtime: row.overtime,
        nightdiff: row.nightdiff,
        restday: row.restday,
      }
      return acc
    }, {}),
  )

  const labelDisplayedRows = ({from, to, count}) => {
    return `${from}-${to} of ${count}`
  }

  const handleStoreChange = async (value) => {
    if (value === selectedCompany || value === null) return
    setLoading(true)
    const fomattedDate = moment(date).format('YYYY-MM-DD')
    setSelectedCompany(value)
    setLoading(false)
  }

  const handleOpenQRModal = async () => {
    setOpenQR(true)
  }

  const handleCloseQR = () => {
    setOpenQR(false)
  }

  const handleError = (err) => {
    alert(err)
  }

  // const load = async () => {
  //   setLoading(true)
  //   const local_user = await storage.getUser()
  //   if (!local_user) return

  //   const user = await JSON.parse(local_user)
  //   const fomattedDate = moment(date).format('YYYY-MM-DD')
  //   let result
  //   let data
  //   let length
  //   if (user.role === 3) {
  //     const getCompany = await userAPI.get_group_store(user._id);
  //     if (getCompany.status === 200) {
  //       setCompany(getCompany.data.report.store);
  //       setSelectedCompany(getCompany.data.report.store)
  //       data = {
  //         store: getCompany.data.report.store[0],
  //       }
  //       result = await userAPI.get_record_bystore(data, fomattedDate)
  //       length = result.data.length - 1
  //       setUsers(result.data.records)
  //       setCount(result.data.count)
  //     }
  //     else {
  //       setUsers()
  //     }
  //   }
  //   else {
  //     const fomattedDate = moment(date).format('YYYY-MM-DD')
  //     data = {
  //       store: user.company,
  //     }
  //     result = await userAPI.get_record_bystore(data, fomattedDate)
  //     length = result.data.length - 1
  //     setUsers(result.data.records)
  //     setCount(result.data.count)
  //   }
  //   /*const getCompany = await userAPI.get_user_company()*/

  //   setUser(user)

  //   setLoading(false)
  // }
  // useEffect(() => {
  //   load()
  // }, [])

  const handleScan = async (res) => {
    const url = new URL(res)
    const pathSegments = url.pathname.split('/')
    const id = pathSegments[1]
    const data = {
      uid: user._id,
      storeid: id,
    }
    if (res) {
      const result = await userAPI.post_group_store(data)
      if (result.status === 200) {
        // load()
        setOpenQR(false)
        alert('Success')
      } else {
        alert('Something went wrong please try again later!')
      }
    } else {
      alert('No link found in the response.')
    }
  }

  const handleDeleteStore = async () => {
    setLoading(true)
    const data = {
      store: selectedCompany,
      id: user._id,
    }
    const result = await userAPI.delete_group_store(data)
    const getCompany = await userAPI.get_group_store(user._id)
    if (getCompany.status === 200) {
      if (getCompany.data.report.store.length > 0) {
        setCompany(getCompany.data.report.store)
        setSelectedCompany(getCompany.data.report.store[0])
      } else {
        setCompany([])
        setSelectedCompany()
      }

      const data = {
        store: getCompany.data.report.store[0],
      }
    } else {
      setStoreBreaklist()
    }
    setLoading(false)
  }

  // const remarkRow = filteredSchedule.find((row, index) => index === addRemarksMode)
  // const employeeRecordData = filteredUsers.find(row => row._id === open)

  const formatNumber = (value, decimals = 2) => {
    if (value === null || value === undefined || value === '') {
      return '0.00'
    }
    // Convert to number, handle string inputs
    const num = typeof value === 'string' ? parseFloat(value) : Number(value)
    // Return 0 if not a valid number
    if (isNaN(num)) {
      return '0.00'
    }
    // For hours worked and other metrics, convert negative to 0
    const validNum = num < 0 ? 0 : num
    // Format to specified decimal places and return as string to maintain precision
    return validNum.toFixed(decimals)
  }

  return (
    <Page title="Breaklist | Time In">
      <Container maxWidth="xl">
        {isMobile ? (
          <>
            <Grid container spacing={3}>
              {user && user.role >= 3 && (
                <Grid item xs={12} md={6}>
                  <FormControl sx={{mt: 4, width: '100%'}}>
                    <Box display="flex" alignItems="center">
                      <Autocomplete
                        id="store-select"
                        value={selectedCompany === null ? company[0] : selectedCompany}
                        onChange={(event, value) => handleStoreChange(value)}
                        options={company}
                        renderInput={(params) => <TextField {...params} label="Store" />}
                        sx={{
                          flexGrow: 1,
                          whiteSpace: 'nowrap',
                          overflow: 'auto',
                          textOverflow: 'ellipsis',
                          pt: 1,
                        }}
                      />
                      <IconButton color="primary" aria-label="add store" onClick={handleOpenQRModal} sx={{ml: 1}}>
                        <AddIcon />
                      </IconButton>
                      <IconButton color="primary" aria-label="delete store" onClick={handleDeleteStore} sx={{ml: 1}}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12}>
                <SearchStyle
                  value={filterName}
                  onChange={handleFilterByName}
                  placeholder="Search user by name"
                  sx={{
                    width: '100%',
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <Box component={Icon} icon={searchFill} sx={{color: 'text.disabled'}} />
                    </InputAdornment>
                  }
                />
                {/*<UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} 
                  />*/}
              </Grid>

              <Grid item xs={6}>
                <FormControl sx={{width: '100%'}}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="From"
                      value={fromDate}
                      minDate={new Date('2017-01-01')}
                      maxDate={yesterday}
                      renderInput={(params) => <TextField {...params} />}
                      onChange={(date) => handleChangeFromDate(date)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{width: '100%'}}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="To"
                      value={toDate}
                      minDate={new Date('2017-01-01')}
                      renderInput={(params) => <TextField {...params} />}
                      onChange={(date) => handleChangeToDate(date)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl sx={{width: '100%'}}>
                  <Button variant="contained" to="#" onClick={handleGenerateBreaklist}>
                    Generate
                  </Button>
                </FormControl>
              </Grid>
            </Grid>

            {/* add margins and show it on the right most side */}
            <Typography variant="h6" gutterBottom sx={{mt: 2, ml: 2, mr: 2, textAlign: 'center'}}>
              {filteredStoreBreaklist.length} Employees Found
            </Typography>
            <Grid container spacing={2}>
              {filteredStoreBreaklist
                // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  const {
                    _id,
                    empName,
                    dayswork,
                    hourswork,
                    hourstardy,
                    nightdiff,
                    overtime,
                    restday,
                    legalholiday,
                    specialholiday,
                  } = row

                  let totalValuesOfUser = totalValuesOfUserId(_id)
                  const isItemSelected = selected.indexOf(_id) !== -1

                  // Calculate total values including any edits
                  const totalHoursTardy = Number(hourstardy) + Number(totalValuesOfUser.hoursTardy || 0)
                  const totalOvertime = Number(overtime) + Number(totalValuesOfUser.overtime || 0)
                  const totalNightDiff = Number(nightdiff) + Number(totalValuesOfUser.nightdiff || 0)
                  const totalRestDay = Number(restday) + Number(totalValuesOfUser.rd || 0)

                  return (
                    <Grid item xs={12} key={_id}>
                      <Card
                        sx={{
                          boxShadow: 2,
                          borderRadius: 2,
                          bgcolor: 'background.paper',
                          '&:hover': {
                            boxShadow: 5,
                          },
                        }}
                      >
                        <CardContent>
                          <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
                            <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                              {empName}
                            </Typography>
                            <Button variant="outlined" size="small" onClick={() => handleCellClick(_id)}>
                              View Details
                            </Button>
                          </Box>

                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Days Worked:
                              </Typography>
                              <Typography variant="body1">{formatNumber(dayswork, 1)}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Hours Worked:
                              </Typography>
                              <Typography variant="body1">{formatNumber(hourswork)}</Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Tardiness (Minutes):
                              </Typography>
                              <Typography variant="body1" sx={{color: totalHoursTardy > 0 ? 'red' : 'inherit'}}>
                                {formatNumber(totalHoursTardy)}
                              </Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Overtime (Hours):
                              </Typography>
                              <Typography variant="body1">{formatNumber(totalOvertime)}</Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Night Diff (Hours):
                              </Typography>
                              <Typography variant="body1">{formatNumber(totalNightDiff)}</Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Rest Day (Hours):
                              </Typography>
                              <Typography variant="body1">{formatNumber(totalRestDay)}</Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Legal Holiday (Hours):
                              </Typography>
                              <Typography variant="body1">{formatNumber(legalholiday)}</Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography variant="body2" color="text.secondary">
                                Special Holiday (Hours):
                              </Typography>
                              <Typography variant="body1">{formatNumber(specialholiday)}</Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )
                })}

              {filteredStoreBreaklist.length === 0 && (
                <Grid item xs={12}>
                  <Typography align="center">No users found</Typography>
                </Grid>
              )}

              <Grid container sx={{direction: 'row', justifyContent: 'center'}}>
                <Button
                  variant="contained"
                  color="success"
                  sx={{m: 2, mr: 0, width: '100%'}}
                  onClick={handleSubmit}
                  disabled={filteredStoreBreaklist.length === 0}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
            <Fab
              color="primary"
              aria-label="scroll back to top"
              sx={{
                position: 'fixed',
                bottom: 26,
                left: '50%',
                transform: 'translateX(-50%)',
                opacity: 0.8,
              }}
              onClick={() => window.scrollTo(0, 0)}
            >
              <KeyboardArrowUpIcon />
            </Fab>
          </>
        ) : (
          <>
            {isLoading ? (
              <Box sx={{height: '50vh'}}>
                <LoadingScreen />
              </Box>
            ) : (
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={5}>
                    {user && user.role >= 3 && (
                      <FormControl fullWidth sx={{mt: 2, ml: 3}}>
                        <Box display="flex" alignItems="center">
                          <Autocomplete
                            id="store-select"
                            value={selectedCompany === null ? company[0] : selectedCompany}
                            onChange={(event, value) => handleStoreChange(value)}
                            options={company}
                            placeholder="Store"
                            renderInput={(params) => <TextField {...params} label="Store" />}
                            sx={{
                              flexGrow: 1,
                              whiteSpace: 'nowrap',
                              overflow: 'auto',
                              textOverflow: 'ellipsis',
                              pt: 1,
                            }}
                          />
                          <IconButton color="primary" aria-label="add store" onClick={handleOpenQRModal} sx={{ml: 1}}>
                            <AddIcon />
                          </IconButton>
                          <IconButton
                            color="primary"
                            aria-label="delete store"
                            onClick={handleDeleteStore}
                            sx={{ml: 1}}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </FormControl>
                    )}
                    <UserListToolbar
                      numSelected={selected.length}
                      filterName={filterName}
                      onFilterName={handleFilterByName}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl sx={{mt: isMobile ? 1 : 2.5, ml: 3, width: '85%'}}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="From"
                          value={fromDate}
                          minDate={new Date('2017-01-01')}
                          maxDate={yesterday}
                          renderInput={(params) => <TextField {...params} />}
                          onChange={(date) => handleChangeFromDate(date)}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl sx={{mt: isMobile ? 1 : 2.5, ml: 3, width: '86.5%'}}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="To"
                          value={toDate}
                          minDate={new Date('2017-01-01')}
                          renderInput={(params) => <TextField {...params} />}
                          onChange={(date) => handleChangeToDate(date)}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                      <FormControl sx={{mt: isMobile ? 1 : 4, width: '50%'}}>
                        <Button variant="contained" to="#" onClick={handleGenerateBreaklist}>
                          Generate
                        </Button>
                      </FormControl>
                    </Box>
                  </Grid>
                </Grid>
                <Scrollbar>
                  <TableContainer sx={{minWidth: 800}}>
                    {storeBreaklist ? (
                      <Table>
                        <TableHead>
                          <UserListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={TABLE_HEAD}
                            rowCount={storeBreaklist ? storeBreaklist.length : 0}
                            numSelected={selected.length}
                            onRequestSort={handleRequestSort}
                            onSelectAllClick={handleSelectAllClick}
                          />
                        </TableHead>
                        <TableBody>
                          {filteredStoreBreaklist
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                              const {
                                _id,
                                empName,
                                dayswork,
                                hourswork,
                                hourstardy,
                                nightdiff,
                                overtime,
                                restday,
                                legalholiday,
                                specialholiday,
                              } = row

                              let totalValuesOfUser = totalValuesOfUserId(_id)

                              const isItemSelected = selected.indexOf(_id) !== -1

                              return (
                                <TableRow
                                  hover
                                  key={_id}
                                  tabIndex={-1}
                                  role="checkbox"
                                  selected={isItemSelected}
                                  aria-checked={isItemSelected}
                                >
                                  {/*<TableCell padding="checkbox">
                                <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
                              </TableCell>*/}
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    padding="none"
                                    onClick={() => handleCellClick(_id)}
                                    sx={{
                                      ml: 2,
                                      fontWeight: 'bold',
                                      textDecoration: 'underline',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        color: 'primary.main',
                                      },
                                    }}
                                  >
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                      <Avatar sx={{ml: 2}} alt={empName} className="ml-3" />
                                      <Typography variant="subtitle2" noWrap>
                                        {empName}
                                      </Typography>
                                    </Stack>
                                  </TableCell>
                                  <TableCell align="left">{formatNumber(dayswork, 1)}</TableCell>
                                  <TableCell align="left">{formatNumber(hourswork)}</TableCell>
                                  <TableCell align="left" style={{color: hourstardy > 0 ? 'red' : 'inherit'}}>
                                    {formatNumber(Number(hourstardy) + Number(totalValuesOfUser.hoursTardy))}
                                  </TableCell>
                                  <TableCell align="left">
                                    {formatNumber(Number(overtime) + Number(totalValuesOfUser.overtime))}
                                  </TableCell>
                                  <TableCell align="left">
                                    {formatNumber(Number(nightdiff) + Number(totalValuesOfUser.nightdiff))}
                                  </TableCell>
                                  <TableCell align="left">
                                    {formatNumber(Number(restday) + Number(totalValuesOfUser.rd))}
                                  </TableCell>
                                  <TableCell align="left">{formatNumber(legalholiday)}</TableCell>
                                  <TableCell align="left">{formatNumber(specialholiday)}</TableCell>
                                </TableRow>
                              )
                            })}
                          <TableRow style={{backgroundColor: '#e0e0e0'}}>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              Total
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  const daysWorkVal = Number(user.dayswork ?? 0)
                                  return sum + (!isNaN(daysWorkVal) && daysWorkVal >= 0 ? daysWorkVal : 0)
                                }, 0),
                                1,
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  const hoursWorkVal = Number(user.hourswork ?? 0)
                                  return sum + (!isNaN(hoursWorkVal) && hoursWorkVal >= 0 ? hoursWorkVal : 0)
                                }, 0),
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  let hoursTardy = Number(user.hourstardy || 0)
                                  let editedHoursTardy = Number(totalValuesOfUserId(user._id).hoursTardy || 0)
                                  let totalHoursTardy = editedHoursTardy + hoursTardy
                                  return sum + (!isNaN(totalHoursTardy) ? totalHoursTardy : 0)
                                }, 0),
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  let overtime = Number(user.overtime || 0)
                                  let editedOvertime = Number(totalValuesOfUserId(user._id).overtime || 0)
                                  const totalOvertime = editedOvertime + overtime
                                  return sum + (!isNaN(totalOvertime) ? totalOvertime : 0)
                                }, 0),
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  let nightdiff = Number(user.nightdiff || 0)
                                  let editedNightDiff = Number(totalValuesOfUserId(user._id).nightdiff || 0)
                                  const totalNightDiff = editedNightDiff + nightdiff
                                  return sum + (!isNaN(totalNightDiff) ? totalNightDiff : 0)
                                }, 0),
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  let rd = Number(user.restday || 0)
                                  let editedRd = Number(totalValuesOfUserId(user._id).rd || 0)
                                  const totalRd = editedRd + rd
                                  return sum + (!isNaN(totalRd) ? totalRd : 0)
                                }, 0),
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  const legalHolidayVal = Number(user.legalholiday ?? 0)
                                  return sum + (!isNaN(legalHolidayVal) ? legalHolidayVal : 0)
                                }, 0),
                              )}
                            </TableCell>
                            <TableCell align="left" sx={{fontWeight: 'bold'}}>
                              {formatNumber(
                                filteredStoreBreaklist.reduce((sum, user) => {
                                  const specialHolidayVal = Number(user.specialholiday ?? 0)
                                  return sum + (!isNaN(specialHolidayVal) ? specialHolidayVal : 0)
                                }, 0),
                              )}
                            </TableCell>
                          </TableRow>
                          {emptyRows > 0 && (
                            <TableRow style={{backgroundColor: '#e0e0e0'}}>
                              <TableCell colSpan={6}></TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                        {isUserNotFound && (
                          <TableBody>
                            <TableRow>
                              <TableCell align="center" colSpan={8} sx={{py: 3}}>
                                <SearchNotFound searchQuery={filterName} />
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        )}
                      </Table>
                    ) : (
                      ''
                    )}
                  </TableContainer>
                </Scrollbar>

                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={storeBreaklist ? storeBreaklist.length : 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage={'Rows per page'}
                  labelDisplayedRows={labelDisplayedRows}
                />

                <Grid container sx={{direction: 'row', justifyContent: 'flex-end'}}>
                  <Button
                    variant="contained"
                    color="success"
                    to="#"
                    sx={{m: 2, width: '19%'}}
                    onClick={handleSubmit}
                    disabled={!storeBreaklist || storeBreaklist.length === 0}
                  >
                    Save
                  </Button>
                  {/*                <Button
                  variant="contained"
                  color="primary"
                  to="#"
                  sx={{ m: 2, width: "19%" }}
                  onClick={handleExportBreaklist}
                  disabled={!users || users.length === 0}
                >
                  Export
                </Button>*/}
                </Grid>
              </Card>
            )}
          </>
        )}

        <Modal
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          open={open !== null}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open !== null}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: isMobile ? '90%' : '70%',
                maxHeight: '80vh', // Limits the modal's height to 80% of the viewport
                overflowY: 'auto', // Enables vertical scrolling
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
              }}
            >
              <Typography align="center">
                {filteredStoreBreaklist.find((user) => user._id === open)?.empName + ' (Record)' ?? ''}{' '}
              </Typography>
              {isMobile ? (
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt: 1}}>
                  <Typography variant="body2">Highlighted values are editable by clicking on them</Typography>
                  <IconButton
                    color="primary"
                    onClick={() => {
                      // Force a re-render of the table to show updated values
                      setEmployeeRecord([...employeeRecord])
                    }}
                    sx={{
                      backgroundColor: '#f0f7ff',
                      boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                      '&:hover': {backgroundColor: '#e1f0ff'},
                    }}
                  >
                    <Icon icon={'material-symbols-light:refresh-rounded'} />
                  </IconButton>
                </Box>
              ) : (
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 2}}>
                  <Typography>Highlighted values are editable by clicking on it.</Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      // Force a re-render of the table to show updated values
                      setEmployeeRecord([...employeeRecord])
                      // You can add additional save logic here if needed
                    }}
                  >
                    Refresh Changes
                  </Button>
                </Box>
              )}
              <Button sx={{position: 'absolute', right: 0, top: 12, zIndex: 10}} onClick={() => setOpen(null)}>
                <Icon icon={closeIcon} width={25} height={25} color="#b2b2b2" />
              </Button>
              {
                // isMobile && addRemarksMode === null ?
                isMobile ? (
                  <Box sx={{mt: 4}}>
                    <Typography variant="h6" gutterBottom sx={{ml: 2, textAlign: 'right'}}>
                      {filteredEmployeeRecord.length} found
                    </Typography>
                    {filteredEmployeeRecord ? (
                      <Scrollbar>
                        <Grid container spacing={2}>
                          {filteredEmployeeRecord
                            // .slice(pageSchedule * rowsPerPageSchedule, pageSchedule * rowsPerPageSchedule + rowsPerPageSchedule)
                            .map((row, index) => {
                              const {
                                _id,
                                name,
                                date,
                                from,
                                to,
                                timeIn,
                                timeOut,
                                hoursTardy = 0,
                                overtime = 0,
                                nightdiff = 0,
                                hourswork = 0,
                                rd = 0,
                                legalholiday = 0,
                                specialholiday = 0,
                                remarks = '',
                              } = row

                              const formattedDate = moment(date).format('YYYY-MM-DD')

                              const remarkId = `${_id}-${date}-${timeIn}-${timeOut}`
                              let remark = remarks || addedRemarks.current[`${remarkId}`] || 'No remarks yet.'

                              let tardyValue = Number(
                                scheduleValuesOf(remarkId)?.['hoursTardy'] ?? Number(hoursTardy) ?? 0,
                              )
                              let otValue = Number(scheduleValuesOf(remarkId)?.['overtime'] ?? Number(overtime) ?? 0)
                              let ndValue = Number(scheduleValuesOf(remarkId)?.['nightdiff'] ?? Number(nightdiff) ?? 0)
                              let restdayValue = Number(scheduleValuesOf(remarkId)?.['rd'] ?? Number(rd) ?? 0)

                              const canEdit = timeIn && timeOut && Number(hourswork) > 0

                              return (
                                <Grid item xs={12} key={`${_id}-${index}`}>
                                  <Card
                                    sx={{
                                      boxShadow: 2,
                                      borderRadius: 2,
                                      p: 2,
                                      bgcolor: 'background.paper',
                                      '&:hover': {
                                        boxShadow: 5,
                                      },
                                    }}
                                  >
                                    <Typography variant="h6" gutterBottom>
                                      {name}
                                    </Typography>

                                    <Grid container spacing={2}>
                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Date:
                                        </Typography>
                                        <Typography variant="body1">{formattedDate}</Typography>
                                      </Grid>
                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Shift:
                                        </Typography>
                                        <Typography variant="body1">
                                          {from} to {to}
                                        </Typography>
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Time In:
                                        </Typography>
                                        <Typography variant="body1">{timeIn || '-'}</Typography>
                                      </Grid>
                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Time Out:
                                        </Typography>
                                        <Typography variant="body1">{timeOut || '-'}</Typography>
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Hours Worked:
                                        </Typography>
                                        <Typography variant="body1" sx={{color: hourswork <= 0 ? 'red' : 'inherit'}}>
                                          {hourswork < 0 ? (0).toFixed(2) : parseFloat(hourswork).toFixed(2)}
                                        </Typography>
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Tardiness (Minutes):
                                        </Typography>
                                        {canEdit ? (
                                          <Box
                                            sx={{
                                              backgroundColor: '#f5f5f5',
                                              borderRadius: 1,
                                              border: '1px solid #e0e0e0',
                                              '&:hover': {backgroundColor: '#dedffa'},
                                            }}
                                          >
                                            <Editable
                                              key={`${remarkId}-tardy`}
                                              text={tardyValue}
                                              onEditText={(newTardy, diff) => {
                                                const newValue = newTardy === '' ? 0 : Number(newTardy)

                                                updateSchedValues(
                                                  remarkId,
                                                  {
                                                    hoursTardy: newValue,
                                                  },
                                                  diff,
                                                )

                                                setRecordChanges((prev) => ({
                                                  ...prev,
                                                  [remarkId]: {
                                                    ...prev[remarkId],
                                                    hoursTardy:
                                                      hoursTardy > newValue
                                                        ? -(hoursTardy - newValue)
                                                        : newValue - hoursTardy,
                                                  },
                                                }))

                                                setEmployeeRecord([...employeeRecord])
                                              }}
                                            />
                                          </Box>
                                        ) : (
                                          <Typography variant="body1" sx={{color: tardyValue > 0 ? 'red' : 'inherit'}}>
                                            {tardyValue}
                                          </Typography>
                                        )}
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Overtime (Hours):
                                        </Typography>
                                        {canEdit ? (
                                          <Box
                                            sx={{
                                              backgroundColor: '#f5f5f5',
                                              borderRadius: 1,
                                              border: '1px solid #e0e0e0',
                                              '&:hover': {backgroundColor: '#dedffa'},
                                            }}
                                          >
                                            <Editable
                                              key={`${remarkId}-ot`}
                                              text={otValue}
                                              onEditText={(newOvertime, diff) => {
                                                const newValue = newOvertime === '' ? 0 : Number(newOvertime)

                                                updateSchedValues(
                                                  remarkId,
                                                  {
                                                    overtime: newValue,
                                                  },
                                                  diff,
                                                )

                                                setRecordChanges((prev) => ({
                                                  ...prev,
                                                  [remarkId]: {
                                                    ...prev[remarkId],
                                                    overtime:
                                                      overtime > newValue
                                                        ? -(overtime - newValue)
                                                        : newValue - overtime,
                                                  },
                                                }))

                                                setEmployeeRecord([...employeeRecord])
                                              }}
                                            />
                                          </Box>
                                        ) : (
                                          <Typography variant="body1">{otValue}</Typography>
                                        )}
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Night Diff (Hours):
                                        </Typography>
                                        {canEdit ? (
                                          <Box
                                            sx={{
                                              backgroundColor: '#f5f5f5',
                                              borderRadius: 1,
                                              border: '1px solid #e0e0e0',
                                              '&:hover': {backgroundColor: '#dedffa'},
                                            }}
                                          >
                                            <Editable
                                              key={`${remarkId}-nd`}
                                              text={ndValue}
                                              onEditText={(newNightDiff, diff) => {
                                                const newValue = newNightDiff === '' ? 0 : Number(newNightDiff)

                                                updateSchedValues(
                                                  remarkId,
                                                  {
                                                    nightdiff: newValue,
                                                  },
                                                  diff,
                                                )

                                                setRecordChanges((prev) => ({
                                                  ...prev,
                                                  [remarkId]: {
                                                    ...prev[remarkId],
                                                    nightdiff:
                                                      nightdiff > newValue
                                                        ? -(nightdiff - newValue)
                                                        : newValue - nightdiff,
                                                  },
                                                }))

                                                setEmployeeRecord([...employeeRecord])
                                              }}
                                            />
                                          </Box>
                                        ) : (
                                          <Typography variant="body1">{ndValue}</Typography>
                                        )}
                                      </Grid>

                                      <Grid item xs={6}>
                                        <Typography variant="body2" color="text.secondary">
                                          Rest Day (Hours):
                                        </Typography>
                                        {canEdit ? (
                                          <Box
                                            sx={{
                                              backgroundColor: '#f5f5f5',
                                              borderRadius: 1,
                                              border: '1px solid #e0e0e0',
                                              '&:hover': {backgroundColor: '#dedffa'},
                                            }}
                                          >
                                            <Editable
                                              key={`${remarkId}-rd`}
                                              text={restdayValue}
                                              onEditText={(newRestDay, diff) => {
                                                const newValue = newRestDay === '' ? 0 : Number(newRestDay)

                                                updateSchedValues(
                                                  remarkId,
                                                  {
                                                    rd: newValue,
                                                  },
                                                  diff,
                                                )

                                                setRecordChanges((prev) => ({
                                                  ...prev,
                                                  [remarkId]: {
                                                    ...prev[remarkId],
                                                    rd: rd > newValue ? -(rd - newValue) : newValue - rd,
                                                  },
                                                }))

                                                setEmployeeRecord([...employeeRecord])
                                              }}
                                            />
                                          </Box>
                                        ) : (
                                          <Typography variant="body1">{restdayValue}</Typography>
                                        )}
                                      </Grid>

                                      <Grid item xs={12}>
                                        <Typography variant="body2" color="text.secondary">
                                          Remarks:
                                        </Typography>
                                        <Box
                                          sx={{
                                            backgroundColor: '#f5f5f5',
                                            borderRadius: 1,
                                            border: '1px solid #e0e0e0',
                                            p: 1,
                                            mt: 0.5,
                                          }}
                                        >
                                          <BreaklistRemark
                                            key={remarkId}
                                            id={remarkId}
                                            onSaveRemark={saveRemark}
                                            remarks={remark}
                                          />
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Card>
                                </Grid>
                              )
                            })}

                          {filteredEmployeeRecord.length === 0 && (
                            <Grid item xs={12}>
                              <Typography align="center">No data found</Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Scrollbar>
                    ) : (
                      <Typography>No data found</Typography>
                    )}

                    {/* <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={specificSchedule.length}
                  rowsPerPage={rowsPerPageSchedule}
                  page={pageSchedule}
                  onPageChange={handleChangePageSchedule}
                  onRowsPerPageChange={handleChangeRowsPerPageSchedule}
                  labelRowsPerPage={"Rows per page"}
                /> */}
                  </Box>
                ) : (
                  // : addRemarksMode !== null ?
                  //   <Box sx={{ my: 2 }}>
                  //     <Typography>{`Date: ${employeeRecordData.empName}`}</Typography>
                  //     <Typography>{`Date: ${remarkRow.date}`}</Typography>
                  //     <TextField
                  //       fullWidth
                  //       label="Remarks"
                  //       variant="outlined"
                  //       multiline
                  //       rows={4}
                  //       value={remarks}
                  //       onChange={(e) => setRemarks(e.target.value)}
                  //     />
                  //     <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                  //       <Button variant="contained" color="primary" onClick={handleSaveRemarks}>
                  //         Save
                  //       </Button>
                  //       <Button variant="outlined" color="secondary" onClick={() => setAddRemarksMode(null)}>
                  //         Cancel
                  //       </Button>
                  //     </Stack>
                  //   </Box>
                  // :
                  <>
                    <TableContainer sx={{minWidth: 800, mt: 4}}>
                      {/*daily schedule of an employee in a breaklist*/}
                      {filteredEmployeeRecord ? (
                        <Table>
                          <UserListHead
                            order={order}
                            orderBy={orderBy}
                            headLabel={MODAL_HEAD}
                            rowCount={storeBreaklist ? storeBreaklist.length : 0}
                            numSelected={selected.length}
                            onRequestSort={handleRequestSort}
                            onSelectAllClick={handleSelectAllClick}
                          />
                          <TableBody>
                            {filteredEmployeeRecord
                              .slice(
                                pageSchedule * rowsPerPageSchedule,
                                pageSchedule * rowsPerPageSchedule + rowsPerPageSchedule,
                              )
                              .map((row, index) => {
                                const {
                                  _id,
                                  name,
                                  date,
                                  from,
                                  to,
                                  timeIn,
                                  timeOut,
                                  hoursTardy = 0,
                                  overtime = 0,
                                  nightdiff = 0,
                                  hourswork = 0,
                                  rd = 0,
                                  legalholiday = 0,
                                  specialholiday = 0,
                                  remarks = '',
                                } = row

                                const formattedDate = moment(date).format('YYYY-MM-DD')
                                const isItemSelected = selected.indexOf(name) !== -1
                                let workingHours =
                                  !timeIn && !timeOut && hourswork <= 0
                                    ? 'Absent'
                                    : hourswork <= 0
                                    ? 0
                                    : Number(hourswork).toFixed(1)

                                const remarkId = `${_id}-${date}-${timeIn}-${timeOut}`
                                let remark = remarks || addedRemarks.current[`${remarkId}`] || 'No remarks yet.'

                                let tardyValue = Number(
                                  scheduleValuesOf(remarkId)?.['hoursTardy'] ?? Number(hoursTardy) ?? 0,
                                )
                                let otValue = Number(scheduleValuesOf(remarkId)?.['overtime'] ?? Number(overtime) ?? 0)
                                let ndValue = Number(
                                  scheduleValuesOf(remarkId)?.['nightdiff'] ?? Number(nightdiff) ?? 0,
                                )
                                let restdayValue = Number(scheduleValuesOf(remarkId)?.['rd'] ?? Number(rd) ?? 0)

                                return (
                                  <TableRow
                                    hover
                                    key={`${_id}-${index}`}
                                    tabIndex={-1}
                                    role="checkbox"
                                    selected={isItemSelected}
                                    aria-checked={isItemSelected}
                                  >
                                    {/*<TableCell padding="checkbox">
                                <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
                              </TableCell>*/}
                                    <TableCell component="th" scope="row" padding="none">
                                      <Stack direction="row" alignItems="center" spacing={2}>
                                        <Typography variant="subtitle2" noWrap sx={{ml: 2}}>
                                          {formattedDate}
                                        </Typography>
                                      </Stack>
                                    </TableCell>
                                    <TableCell align="left">
                                      {from} to {to}
                                    </TableCell>
                                    <TableCell align="left">{timeIn}</TableCell>
                                    <TableCell align="left">{timeOut}</TableCell>
                                    <TableCell
                                      align="left"
                                      style={{
                                        color: hourswork <= 0 ? 'red' : 'inherit',
                                        // cursor: hourswork <= 0 && timeOut ? 'pointer' : 'default'
                                      }}
                                      // onClick={() => hourswork <= 0 && timeOut && handleAddRemarks(index)}
                                      // onMouseOver={(e) => {
                                      //   if (hourswork <= 0 && timeOut) {
                                      //     e.target.style.backgroundColor = '#f0f0f0';
                                      //   }
                                      // }}
                                      // onMouseOut={(e) => {
                                      //   if (hourswork <= 0 && timeOut) {
                                      //     e.target.style.backgroundColor = 'inherit';
                                      //   }
                                      // }}
                                    >
                                      {workingHours}
                                    </TableCell>

                                    <TableCell align="left" style={{color: tardyValue > 0 ? 'red' : 'inherit'}}>
                                      {!timeIn || !timeOut || !hourswork || Number(hourswork) <= 0 ? (
                                        tardyValue
                                      ) : (
                                        <Editable
                                          key={`${remarkId}-tardy`}
                                          text={tardyValue}
                                          onEditText={(newTardy, diff) => {
                                            // Convert values to numbers for proper comparison, handle empty strings
                                            const newValue = newTardy === '' ? 0 : Number(newTardy)
                                            const oldValue = Number(tardyValue)

                                            // Always update when new value is different or zero
                                            if (newValue !== oldValue || newValue === 0) {
                                              updateSchedValues(
                                                remarkId,
                                                {
                                                  hoursTardy: newValue,
                                                },
                                                diff,
                                              )

                                              setRecordChanges((prev) => ({
                                                ...prev,
                                                [remarkId]: {
                                                  ...prev[remarkId],
                                                  hoursTardy:
                                                    hoursTardy > newValue
                                                      ? -(hoursTardy - newValue)
                                                      : newValue - hoursTardy,
                                                },
                                              }))

                                              // Trigger a re-render
                                              setEmployeeRecord([...employeeRecord])
                                            }
                                          }}
                                        />
                                      )}
                                    </TableCell>

                                    <TableCell align="left">
                                      {!timeIn || !timeOut || !hourswork || Number(hourswork) <= 0 ? (
                                        otValue
                                      ) : (
                                        <Editable
                                          key={`${remarkId}-ot`}
                                          text={otValue}
                                          onEditText={(newOvertime, diff) => {
                                            // Convert values to numbers for proper comparison, handle empty strings
                                            const newValue = newOvertime === '' ? 0 : Number(newOvertime)
                                            const oldValue = Number(otValue)

                                            // Always update when new value is different or zero
                                            if (newValue !== oldValue || newValue === 0) {
                                              updateSchedValues(
                                                remarkId,
                                                {
                                                  overtime: newValue,
                                                },
                                                diff,
                                              )

                                              setRecordChanges((prev) => ({
                                                ...prev,
                                                [remarkId]: {
                                                  ...prev[remarkId],
                                                  overtime:
                                                    overtime > newValue ? -(overtime - newValue) : newValue - overtime,
                                                },
                                              }))

                                              // Trigger a re-render
                                              setEmployeeRecord([...employeeRecord])
                                            }
                                          }}
                                        />
                                      )}
                                    </TableCell>

                                    <TableCell align="left">
                                      {!timeIn || !timeOut || !hourswork || Number(hourswork) <= 0 ? (
                                        ndValue
                                      ) : (
                                        <Editable
                                          key={`${remarkId}-nd`}
                                          text={ndValue}
                                          onEditText={(newNightDiff, diff) => {
                                            // Convert values to numbers for proper comparison, handle empty strings
                                            const newValue = newNightDiff === '' ? 0 : Number(newNightDiff)
                                            const oldValue = Number(ndValue)

                                            // Always update when new value is different or zero
                                            if (newValue !== oldValue || newValue === 0) {
                                              updateSchedValues(
                                                remarkId,
                                                {
                                                  nightdiff: newValue,
                                                },
                                                diff,
                                              )

                                              setRecordChanges((prev) => ({
                                                ...prev,
                                                [remarkId]: {
                                                  ...prev[remarkId],
                                                  nightdiff:
                                                    nightdiff > newValue
                                                      ? -(nightdiff - newValue)
                                                      : newValue - nightdiff,
                                                },
                                              }))

                                              // Trigger a re-render
                                              setEmployeeRecord([...employeeRecord])
                                            }
                                          }}
                                        />
                                      )}
                                    </TableCell>

                                    <TableCell align="left">
                                      {!timeIn || !timeOut || !hourswork || Number(hourswork) <= 0 ? (
                                        restdayValue
                                      ) : (
                                        <Editable
                                          key={`${remarkId}-rd`}
                                          text={restdayValue}
                                          onEditText={(newRestDay, diff) => {
                                            // Convert values to numbers for proper comparison, handle empty strings
                                            const newValue = newRestDay === '' ? 0 : Number(newRestDay)
                                            const oldValue = Number(restdayValue)

                                            // Always update when new value is different or zero
                                            if (newValue !== oldValue || newValue === 0) {
                                              updateSchedValues(
                                                remarkId,
                                                {
                                                  rd: newValue,
                                                },
                                                diff,
                                              )

                                              setRecordChanges((prev) => ({
                                                ...prev,
                                                [remarkId]: {
                                                  ...prev[remarkId],
                                                  rd: rd > newValue ? -(rd - newValue) : newValue - rd,
                                                },
                                              }))
                                              // Trigger a re-render
                                              setEmployeeRecord([...employeeRecord])
                                            }
                                          }}
                                        />
                                      )}
                                    </TableCell>
                                    <TableCell align="left">{legalholiday}</TableCell>
                                    <TableCell align="left">
                                      {specialholiday && specialholiday <= 0 ? 0 : specialholiday}
                                    </TableCell>
                                    <TableCell align="left">
                                      <BreaklistRemark
                                        key={remarkId}
                                        id={remarkId}
                                        onSaveRemark={saveRemark}
                                        remarks={remark}
                                      />
                                    </TableCell>
                                    <TableCell align="left">
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        startIcon={<EditIcon />}
                                        onClick={() => handleEditSchedule(_id, formattedDate)}
                                      >
                                        Schedule
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                )
                              })}

                            {/*totalities here*/}
                            <TableRow style={{backgroundColor: '#e0e0e0'}}>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                Total
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                -
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                -
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                -
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {formatNumber(
                                  filteredEmployeeRecord.reduce((sum, row) => {
                                    const hoursWorkVal = Number(row.hourswork ?? 0)
                                    return sum + (!isNaN(hoursWorkVal) && hoursWorkVal >= 0 ? hoursWorkVal : 0)
                                  }, 0),
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {formatNumber(
                                  filteredEmployeeRecord.reduce((sum, row) => {
                                    if (!row.hourswork || Number(row.hourswork) <= 0) return sum

                                    // Original value (default to 0)
                                    let hoursTardy = Number(row.hoursTardy || 0)

                                    // Get record ID for scheduleValues lookup
                                    const recordId = `${row._id}-${row.date}-${row.timeIn}-${row.timeOut}`

                                    // Get the schedule value, explicitly checking for null/undefined
                                    const scheduleValue = scheduleValuesOf(recordId)

                                    // If there's a schedule value entry, it overrides the original value completely
                                    // This ensures backspacing to 0 works properly
                                    if (scheduleValue && 'hoursTardy' in scheduleValue) {
                                      return sum + Number(scheduleValue.hoursTardy || 0)
                                    }

                                    // Otherwise use the original value
                                    return sum + hoursTardy
                                  }, 0),
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {formatNumber(
                                  filteredEmployeeRecord.reduce((sum, row) => {
                                    if (!row.hourswork || Number(row.hourswork) <= 0) return sum

                                    // Original value (default to 0)
                                    let overtime = Number(row.overtime || 0)

                                    // Get record ID for scheduleValues lookup
                                    const recordId = `${row._id}-${row.date}-${row.timeIn}-${row.timeOut}`

                                    // Get the schedule value, explicitly checking for null/undefined
                                    const scheduleValue = scheduleValuesOf(recordId)

                                    // If there's a schedule value entry, it overrides the original value completely
                                    // This ensures backspacing to 0 works properly
                                    if (scheduleValue && 'overtime' in scheduleValue) {
                                      return sum + Number(scheduleValue.overtime || 0)
                                    }

                                    // Otherwise use the original value
                                    return sum + overtime
                                  }, 0),
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {formatNumber(
                                  filteredEmployeeRecord.reduce((sum, row) => {
                                    if (!row.hourswork || Number(row.hourswork) <= 0) return sum

                                    // Original value (default to 0)
                                    let nightdiff = Number(row.nightdiff || 0)

                                    // Get record ID for scheduleValues lookup
                                    const recordId = `${row._id}-${row.date}-${row.timeIn}-${row.timeOut}`

                                    // Get the schedule value, explicitly checking for null/undefined
                                    const scheduleValue = scheduleValuesOf(recordId)

                                    // If there's a schedule value entry, it overrides the original value completely
                                    // This ensures backspacing to 0 works properly
                                    if (scheduleValue && 'nightdiff' in scheduleValue) {
                                      return sum + Number(scheduleValue.nightdiff || 0)
                                    }

                                    // Otherwise use the original value
                                    return sum + nightdiff
                                  }, 0),
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {formatNumber(
                                  filteredEmployeeRecord.reduce((sum, row) => {
                                    if (!row.hourswork || Number(row.hourswork) <= 0) return sum

                                    // Original value (default to 0)
                                    let rd = Number(row.rd || 0)

                                    // Get record ID for scheduleValues lookup
                                    const recordId = `${row._id}-${row.date}-${row.timeIn}-${row.timeOut}`

                                    // Get the schedule value, explicitly checking for null/undefined
                                    const scheduleValue = scheduleValuesOf(recordId)

                                    // If there's a schedule value entry, it overrides the original value completely
                                    // This ensures backspacing to 0 works properly
                                    if (scheduleValue && 'rd' in scheduleValue) {
                                      return sum + Number(scheduleValue.rd || 0)
                                    }

                                    // Otherwise use the original value
                                    return sum + rd
                                  }, 0),
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {formatNumber(
                                  filteredEmployeeRecord.reduce((sum, row) => {
                                    const legalHolidayVal = Number(row.legalholiday ?? 0)
                                    return sum + (!isNaN(legalHolidayVal) ? legalHolidayVal : 0)
                                  }, 0),
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                {formatNumber(
                                  filteredEmployeeRecord.reduce((sum, row) => {
                                    const specialHolidayVal = Number(row.specialholiday ?? 0)
                                    return sum + (!isNaN(specialHolidayVal) ? specialHolidayVal : 0)
                                  }, 0),
                                )}
                              </TableCell>
                              <TableCell align="left" sx={{fontWeight: 'bold'}}>
                                -
                              </TableCell>
                            </TableRow>
                            {emptyRows > 0 && (
                              <TableRow style={{backgroundColor: '#e0e0e0'}}>
                                <TableCell colSpan={6}></TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                          {isUserNotFound && (
                            <TableBody>
                              <TableRow>
                                <TableCell align="center" colSpan={8} sx={{py: 3}}>
                                  <SearchNotFound searchQuery={filterName} />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                        </Table>
                      ) : (
                        'No data found'
                      )}
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={employeeRecord.length}
                      rowsPerPage={rowsPerPageSchedule}
                      page={pageSchedule}
                      onPageChange={handleChangePageSchedule}
                      onRowsPerPageChange={handleChangeRowsPerPageSchedule}
                      labelRowsPerPage={'Rows per page'}
                      labelDisplayedRows={labelDisplayedRows}
                    />
                  </>
                )
              }

              {/*<Button variant="contained" color="success" onClick={handleSaveUpdates} sx={{ mt: 2, px: 17 }}>
                Submit
              </Button>*/}
            </Box>
          </Fade>
        </Modal>

        <Modal
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          open={openDialog}
          onClose={() => {
            setOpenDialog(false)
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openDialog}>
            <Box alignContent="center" sx={style}>
              <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button
                  sx={{mb: 1}}
                  onClick={() => {
                    setOpenDialog(false)
                  }}
                >
                  <Icon icon={closeIcon} width={20} height={20} color="#b2b2b2" />
                </Button>
              </Box>
              <Typography align="center" variant="h6">
                Are you sure you want to submit this break list? Once submitted, the store accounting department can
                review it and forward it to payroll.
              </Typography>
              <TextField
                label="Submitted By:"
                fullWidth
                value={submittedBy}
                onChange={handleInputChange}
                margin="normal"
                variant="outlined"
              />
              <FormControl required sx={{mt: 3}}>
                <FormLabel id="demo-row-radio-buttons-group-label">Cutoff</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  defaultValue="1"
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="1st Cutoff"
                    onChange={(e) => setCutoff(e.target.value)}
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="2nd Cutoff"
                    onChange={(e) => setCutoff(e.target.value)}
                  />
                </RadioGroup>
              </FormControl>
              <Button
                disabled={submittedBy ? false : true}
                onClick={handleSaveBreaklist}
                variant="contained"
                color="success"
                sx={{mt: 2, px: 19}}
              >
                Submit
              </Button>
            </Box>
          </Fade>
        </Modal>

        <Modal
          aria-labelledby="spring-modal-title"
          aria-describedby="spring-modal-description"
          open={openDialogGenerate}
          onClose={() => setOpenDialogGenerate(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{timeout: 500}}
        >
          <Fade in={openDialogGenerate}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                maxWidth: 500,
                bgcolor: 'background.paper',
                boxShadow: 24,
                borderRadius: 3,
                p: 4,
              }}
            >
              <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button onClick={() => setOpenDialogGenerate(false)} sx={{minWidth: 'unset', p: 0}}>
                  <Icon icon={closeIcon} width={24} height={24} color="#9e9e9e" />
                </Button>
              </Box>
              <Typography id="spring-modal-title" variant="h5" align="center" gutterBottom sx={{fontWeight: 600}}>
                Ready to generate the breaklist?
              </Typography>
              <Typography
                id="spring-modal-description"
                variant="body1"
                align="center"
                sx={{mt: 2, color: 'text.secondary'}}
              >
                Please double-check the schedule and existing records before proceeding to avoid any conflicts.
              </Typography>
              <Box sx={{display: 'flex', justifyContent: 'center', mt: 4}}>
                <Button
                  onClick={handleCloseModal}
                  variant="contained"
                  color="success"
                  sx={{px: 6, py: 1.5, borderRadius: 2, fontWeight: 500}}
                >
                  Ok
                </Button>
              </Box>
            </Box>
          </Fade>
        </Modal>

        <Dialog open={openUpdates} onClose={handleClose}>
          <DialogTitle>Update Values?</DialogTitle>
          <DialogContent>
            <TextField
              error
              autoFocus
              margin="dense"
              id="name"
              label="Tardy Minutes"
              type="number"
              fullWidth
              variant="standard"
            />
            <TextField error margin="dense" id="name" label="Overtime" type="number" fullWidth variant="standard" />
            <TextField error margin="dense" id="name" label="Night Diff" type="number" fullWidth variant="standard" />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseUpdates}>Cancel</Button>
            <Button>Submit</Button>
          </DialogActions>
        </Dialog>
        <CSVLink
          ref={csvLinkRef}
          filename={`Breaklist summary for ${user.company} - ${fromDate} to ${toDate}.csv`}
          data={getCsvData()}
          style={{display: 'none'}} // Hide the CSVLink button
        />
      </Container>

      <Dialog open={openQR} onClose={handleCloseQR}>
        <DialogTitle>
          Scan store QR code.
          <IconButton
            aria-label="close"
            onClick={handleCloseQR}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <>
            <QrReader
              delay={3000}
              onError={handleError}
              onScan={handleScan}
              // chooseDeviceId={()=>selected}
              style={{width: '250px', heigth: '200px'}}
              // className={'qrScanner'}
            />
            {/*<DialogTitle style={{ display: "flex", justifyContent: "center" }}><a href="https://www.sparkletimekeeping.com/store/create">Register store account</a></DialogTitle>*/}
          </>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openCreateScheduleDialog}
        onClose={() => setOpenCreateScheduleDialog(false)}
        fullWidth
        maxWidth="xs"
        disableScrollLock={true}
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseCreateScheduleDialog}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle sx={{fontWeight: 'bold', textAlign: 'center'}}>Edit Schedule</DialogTitle>
        <DialogContent sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
          <TextField
            label="Time-in"
            type="time"
            fullWidth
            variant="outlined"
            margin="dense"
            value={from}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{sx: {fontSize: '0.9rem'}, step: 300}}
            onChange={(e) => setFrom(e.target.value)}
          />
          <TextField
            label="Time-out"
            fullWidth
            type="time"
            variant="outlined"
            margin="dense"
            value={to}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{sx: {fontSize: '0.9rem'}, step: 300}}
            onChange={(e) => setTo(e.target.value)}
          />
          <TextField
            label="No. of breaks (mins)"
            fullWidth
            type="number"
            variant="outlined"
            margin="dense"
            value={breakMin}
            onChange={(e) => setBreakMin(e.target.value)}
          />
          <TextField
            label="Position"
            fullWidth
            type="text"
            variant="outlined"
            value={position}
            margin="dense"
            onChange={(e) => setPosition(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{justifyContent: 'center'}}>
          <Button
            variant="contained"
            onClick={handleSaveSchedule}
            sx={{
              backgroundColor: '#2194F3',
              borderRadius: '8px',
              padding: '8px 16px',
              fontWeight: 'bold',
              color: 'white',
              '&:hover': {backgroundColor: '#1976D2'},
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  )
}

